"use client"
import Line from "@/components/ui/line";
import {Accordion,} from "@/components/ui/accordion"
import React, {useContext, useEffect, useRef, useState} from "react";
import IconTexeLine from "@/components/icon-texe-line";
import AccordionService from "@/components/accordion";
import {Popup} from "@/components/popup";
import Start from "@/components/start-block";
import {PageData} from "@/intefaces/page.props";
import {PopupContext} from "@/context/PopupContext";
import {P} from "@/components/ui/P";
import {initializeCookies} from "@/helpers/cookies";
import Stages from "@/components/stages";
import {PATH} from "@/data/path";
import Service from "@/components/servise";
import FormOrder from "@/components/form-order";
import MainBanner from "@/components/baner/MainBanner";
import Team from "@/components/team";
import {AdsCorusel} from "@/components/adsPage/AdsCorusel";
import History from "@/components/history";
import Owner from "@/components/owner";

export default function DynamicPage(data: PageData) {
    const [selectedObjectIndex, setSelectedObjectIndex] = useState(0);
    const cardRef = useRef<HTMLDivElement>(null);
    const analyzedRef = useRef<HTMLDivElement>(null);
    const selectedObject = data?.cardObject?.[selectedObjectIndex];
    const {openPopup, closePopup, isPopupOpen, currentData, afterActionPopup} = useContext(PopupContext);

    useEffect(() => {
        const hasPopupShown = localStorage.getItem('popupShown');
        if (!hasPopupShown) {
            const timer = setTimeout(() => {
                openPopup('action-analyze');
                localStorage.setItem('popupShown', 'true');
            }, 25000);
            return () => clearTimeout(timer);
        }
    }, [openPopup]);

    useEffect(() => {
        const initCookies = async () => {
            await initializeCookies();
        };
        initCookies();
    }, []);

    const handleIconClick = (index: number) => {
        setSelectedObjectIndex(index);
        if (cardRef.current) {
            cardRef.current.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        }
    };

    const isSellPage = data?.id.includes(PATH.PRODAT_KVARTIRU);
    const isaAboutPage = data?.id.includes(PATH.ABOUT);

    const teamBlock = () => {
        if (isaAboutPage) {
            return <Team/>
        } else {
            return null;
        }
    }

    return (
        <div className={''}>
            <div className='mb-14 px-4'>
                    <MainBanner/>

                <Start
                    title={data?.title}
                    description={data?.description}
                    after={data?.after}
                    preTitle={data?.preTitle}
                />
            </div>

            <div className="max-w-custom mx-auto px-3 my-14">
                <P size="l" className="text-gray-400 ml-6 lg:ml-9 mb-6">Наши партнёры:</P>

                <div
                    className="
                    ml-2 lg:ml-9
            flex
            gap-5
            overflow-x-auto
            px-4
            scrollbar-hide
            opacity-60
            sm:justify-between

            sm:gap-0
            sm:px-0
        "
                >
                    <img src="/sber.png" alt="Сбер" className="h-14 lg:h-20 "/>
                    <img src="/vtb.png" alt="ВТБ" className="h-14  lg:h-20 "/>
                    <img src="/dom.png" alt="Дом.РФ" className="h-14  lg:h-20"/>
                    <img src="/sber.png" alt="Сбер" className="h-14 lg:h-20 "/>
                    <img src="/alfa.png" alt="Альфа" className="h-14 lg:h-20 "/>
                </div>
            </div>

            {isSellPage ? <History/> : null}
            <AdsCorusel isSellPage={isSellPage}/>
            <div className="max-w-custom mx-auto" ref={analyzedRef}>
                <Owner/>
                <div className={' flex items-center gap-3 px-3 mx-auto'}>
                    {/*<DoorOpen color={'green'} size={40}/>*/}
                    <P size={'l'} className={'text-gray-400 ml-6 lg:ml-8'}>Наши услуги:</P>
                </div>
                <Service cardsService={data.cardsService}/>

                {isSellPage ? <> <Stages/> <Line/> </> : null}
                <div className="my-14 px-3">
                    <P size={'l'}>С какими объектами мы работаем</P>
                    <div className="grid grid-cols-2 gap-5 lg:grid-cols-6 mt-14">
                        {data?.withObjet?.map((service, index) => (
                            <IconTexeLine
                                key={index}
                                size='m'
                                className='  gap-3 content-center relative group bg-gradient-to-br from-green-100 via-white to-green-50 p-6 rounded-3xl border border-green-300 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col'
                                description={service.title}
                                path={service.path}
                                onClick={() => handleIconClick(index)}
                            />
                        ))}
                    </div>
                </div>
                {/*{teamBlock()}*/}
                {/*<AboutObject ref={cardRef} {...selectedObject} className={'my-14'}/>*/}
                <Line/>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 px-3 my-14">
                    <div>
                        <P size={'l'} className={'mb-6'}>Частые вопросы</P>
                        <Accordion type="single" collapsible>
                            {selectedObject?.questions?.map((item: any) => (
                                <AccordionService key={item.id} {...item}/>
                            ))}
                        </Accordion>
                    </div>
                    <div
                        className={'group bg-gradient-to-br from-green-100 via-white to-green-50 p-6 rounded-3xl border border-green-300 shadow-md hover:shadow-xl transition-all duration-300'}>
                        <div className={'flex flex-col gap-3 w-full lg:w-[70%] m-auto '} ref={cardRef}>
                            <P size={'l'}>Оставьте заявку</P>
                            <P>Мы перезвоним в течение 30 минут</P>
                            <FormOrder/>
                        </div>
                    </div>
                </div>
                <Line/>
            </div>
            {isPopupOpen && currentData && (
                <Popup isOpen={isPopupOpen} onClose={closePopup} data={currentData}/>
            )}
        </div>
    );
}
